/**
 * Created by Denis Kuzin on 05 october 2026
 */

const AlertWindow = Prefab.createWindow("alert_window", "alert_window_prefab_json", {
    bundles: (args) => {
        const role = cleverapps.persons.getRole("hero");
        return [args.icons, role && role.bundle].filter(Boolean);
    }
});
